<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="cc-soft-phone" v-if="$store.state.phone.softPhone">
          <div class="cc-soft-phone-time" :style="{ 'background-color': $store.state.phone.callColor }">
            <span>{{ $store.state.phone.callStatus }}</span>
            <span>|</span>
            <span>{{ $store.state.phone.clock }}</span>
          </div>
          <div class="cc-soft-phone-number">
            <el-input placeholder="请输入呼叫号码" v-model="$store.state.phone.callInfo.callee"
              :disabled="!$store.state.phone.callInfo.dialFlag" @input="updateInput" maxlength="15"
              class="input-with-select" size="medium" clearable style="width: 350px;">
              <el-select v-model="caller" slot="prepend" placeholder="请选择外显" clearable>
                <el-option v-for="item in $store.state.phone.disNumber" :key="item" :label="item"
                  :value="item"></el-option>
              </el-select>
              <i slot="append" class="el-icon-edit-outline" @click="onAmend"
                v-if="!$store.state.phone.callInfo.dialFlag && !$store.state.phone.callInfo.copyFlag"></i>
              <i slot="append" class="el-icon-copy-document" id="copy"
                :data-clipboard-text="$store.state.phone.callInfo.showCallee" @click="onCopy"
                v-if="$store.state.phone.callInfo.copyFlag && $store.state.phone.callInfo.showCallee != ''"></i>
            </el-input>
          </div>
          <div class="cc-soft-phone-board">
            <div v-if="$store.state.phone.callout" @click="onPhoneCall">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-call"></use>
              </svg>
              拨打
            </div>
            <div v-if="$store.state.phone.hangup" @click="onPhone('phone-hang-up')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-guaduan"></use>
              </svg>
              挂断
            </div>
            <div v-if="$store.state.phone.hold" @click="onPhone('phone-hold')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-maikefengguan"></use>
              </svg>
              保持
            </div>
           <!--  <div v-if="$store.state.phone.busy" @click="onPhone('phone-sleep')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-fanmang1"></use>
              </svg>
              繁忙
            </div>
            <div v-if="$store.state.phone.unhold" @click="onPhone('phone-un-hold')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-maikefeng"></use>
              </svg>
              取出
            </div>
             <div v-if="$store.state.phone.answer" @click="onPhone('phone-answer')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-call"></use>
              </svg>
              应答
            </div> -->
            <!-- <div v-if="$store.state.phone.transfer1" @click="onRefile">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-phone"></use>
              </svg>
              转移
            </div> -->
            <!-- <div v-if="$store.state.phone.consult" @click="onConsult">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-zixun"></use>
              </svg>
              咨询三方
            </div> -->
            <div v-if="$store.state.phone.finish" @click="onPhone('phone-ready')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-yijieshu"></use>
              </svg>
              结束话后
            </div>
            <div v-if="$store.state.phone.transfer" @click="onRefile">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-zhuanjie"></use>
              </svg>
              转接
            </div>
            <div v-if="$store.state.phone.sleep" @click="onPhone('phone-sleep')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-xiaoxiu"></use>
              </svg>
              小休
            </div>
            <div v-if="$store.state.phone.ready" @click="onPhone('phone-ready')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-jiuxu"></use>
              </svg>
              就绪
            </div>
            <el-popover placement="bottom" width="100" trigger="click">
              <div class="cc-phone-setting">
                <span>自动就绪</span><el-switch v-model="$store.state.phone.autoReady" :active-value="true"
                  :inactive-value="false" @change="onChange"></el-switch>
              </div>
              <div slot="reference">
                <svg class="icons" aria-hidden="true">
                  <use xlink:href="#icon-dianhuashezhi"></use>
                </svg>设置
              </div>
            </el-popover>
            <div v-if="$store.state.phone.logout" @click="onPhone('phone-out')">
              <svg class="icons" aria-hidden="true">
                <use xlink:href="#icon-tuichudenglu-icon"></use>
              </svg>
              签出
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <transition name="el-zoom-in-top">
      <div class="cc-sing-hint" v-if="!$store.state.phone.softPhone && $store.state.phone.softPhoneInfo !== ''">
        <svg class="icons" aria-hidden="true">
          <use xlink:href="#icon-jiqirenshiyitu"></use>
        </svg>
        <div class="cc-sing-hint-msg">
          <div class="cc-sing-hint-msg-say">{{ $store.state.phone.softPhoneInfo }}</div>
        </div>
      </div>
    </transition>
    <!-- 转接 -->
    <el-dialog title="转接" :visible.sync="dialogVisible" width="30%" append-to-body>
      <el-form :model="form" label-position="right" label-width="80px">
        <el-form-item label="转接方式" prop="type">
          <el-select v-model="form.type" placeholder="请选择" size="small" @change="reset">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="技能组" prop="groupId" v-if="form.type == '1' || form.type == '3'">
          <el-select v-model="form.groupId" placeholder="请选择" @change="onGroupId" size="small" clearable>
            <el-option v-for="item in groupList" :key="item.id" :label="item.var" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="坐席" prop="transferNumber"
          v-if="form.groupId !== '' && form.type == '1' || form.type == '3'">
          <el-select v-model="form.transferNumber" placeholder="请选择坐席" size="small" clearable>
            <el-option v-for="item in orderHandlerList" :key="item.userId"
              :label="form.type == '1' ? item.userName : item.userName + '：' + item.userPhone"
              :value="form.type == '1' ? item.userName : item.userPhone">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IVR" prop="ivrId" v-if="form.type == 2">
          <el-select v-model="form.ivrId" placeholder="请输入选择" size="small" clearable>
            <el-option v-for="item in ivrList" :key="item.ivrId" :label="item.ivrName" :value="item.ivrId">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="手机号" prop="caller" v-if="form.type == 3">
          <el-input v-model="form.caller" placeholder="请输入手机号" size="mini" clearable></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="onTransfer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard, { copy } from 'clipboard'
import { Message } from "element-ui";
import { getPhoneControl, phoneCall, phoneTransfer,phoneConsult } from "../../api/softphone/index"
import { selGroupList, groupUsers, selIvrList } from "../../api/index";
export default {
  data () {
    return {
      caller: "", //外显
      dialogVisible: false, //转接
      groupList: [],//技能组
      ivrList: [], //ivr
      form: {}, //转接
      orderHandlerList: [], //技能组坐席
      options: [  //转接方式
        {
          label: "转坐席",
          value: "1",
        },
        // {
        //   label: 'IVR',
        //   value: '2',
        // },
        // {
        //   label: "转手机",
        //   value: "3",
        // },
      ],
    }
  },
  methods: {
    //判断对象是否为空
    isObjectEmpty (obj) {
      return Object.keys(obj).length === 0 && Object.getOwnPropertyNames(obj).length === 0;
    },
    // //修改
    onAmend () {
      let callInfo = { callee: '', showCallee: '', extendId: 0, dialFlag: true, copyFlag: false }
      this.$store.dispatch("callInfo", callInfo);
      this.$emit('onEmpty') //等于一时清空
    },
    // //复制
    onCopy () {
      let clipborad = new Clipboard('#copy')
      //复制成功
      clipborad.on('success', function () {
        Message({
          type: 'success',
          duration: 1000,
          message: '复制成功'
        })
        // 释放内存，如果缺少，复制成功的提示会一直累加 f7e125d5
        clipborad.destroy()
      })
      //复制失败
      clipborad.on('error', function () {
        Message({
          type: 'error',
          duration: 1000,
          message: '复制失败'
        })
        // 释放内存
        clipborad.destroy()
      })
    },
    updateInput (val) {
      let callInfo = { callee: val, showCallee: val, extendId: 0, dialFlag: true, copyFlag: true }
      this.$store.dispatch("callInfo", callInfo);
    },
    //咨询三方
    onConsult(){
      phoneConsult().then(res=>{
        console.log(res)
      })
    },
    //自动就绪
    onChange (val) {
      getPhoneControl('auto-ready').then((res) => {
        if (res.code == 200) {
          this.$store.commit("SET_AUTOREADY", val);
        }
      });
    },
    //软电话操作
    onPhone (action) {
      getPhoneControl(action).then(res => {
        console.log(res)
      })
    },
    //拨打
    onPhoneCall () {
      let callee = this.$store.state.phone.callInfo.callee;
      if (callee == "") {
        this.$notify({
          duration: 1000,
          title: '请输入拨打的手机号',
          type: 'error'
        });
        return;
      }
      let extendId = this.$store.state.phone.callInfo.extendId;
      let query = {
        callee: callee.replace(/\s+/g, ""), //去除手机号中的空格
        caller: this.caller == "" ? "0" : this.caller,
        extendId: extendId == null ? 0 : extendId,
        webRtc:false,
      };
      console.log(query)
      phoneCall(query).then((res) => { });
    },
    //转接
    onRefile () {
      this.dialogVisible = true;
      this.selGroup(); //技能组
      this.getIvrlist(); //ivr
      this.form = {};
    },
    //转接确定
    onTransfer () {
      let eslData = this.$store.state.phone.eslData
      console.log('eslData',this.$store.state.phone.eslData)
      let caller = ''
      let transferNumber = ''
      if (this.form.type == 3) {
        caller = eslData.phone
        transferNumber = this.form.transferNumber
      } else if (this.form.type == 2) {
        caller = this.$store.state.phone.callInfo.callee
        transferNumber = this.form.ivrId
      } else if (this.form.type == 1) {
        caller = this.$store.state.phone.eslData.phone
        transferNumber = this.form.transferNumber
      }
      let query = {
        type: this.form.type,
        transferNumber: transferNumber,
        groupId: this.form.groupId,
        fsIp: eslData.fsIp,
        caller: caller
      };

      console.log('转接参数',query)
      phoneTransfer(query).then((res) => {
        if (res.code == 200) {
          this.dialogVisible = false;
        }
      });
    },
    //技能组事件
    onGroupId (index) {
      let query = {
        groupId: index,
        isTransPhone: this.form.type == '3' ? '1' : null,
      };
      groupUsers(query).then((res) => {
        this.orderHandlerList = res.data;
        console.log(this.orderHandlerList)
      });
    },
    //技能组
    selGroup () {
      selGroupList().then((res) => {
        this.groupList = res.data;
      });
    },
    //ivr
    getIvrlist () {
      selIvrList().then((res) => {
        this.ivrList = res.data;
      });
    },
    //转接方式
    reset (index) {
      this.form = {
        type: index,
        groupId: null,
        ivrId: null,
        transferNumber: ''
      };
      this.resetForm("form");
    },
  }
}
</script>

<style lang="scss" scoped></style>